import { render, staticRenderFns } from "./FabricForm.vue?vue&type=template&id=b3ba0240&scoped=true"
import script from "./FabricForm.vue?vue&type=script&lang=js"
export * from "./FabricForm.vue?vue&type=script&lang=js"
import style0 from "./FabricForm.vue?vue&type=style&index=0&id=b3ba0240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ba0240",
  null
  
)

export default component.exports